/* 
Pantalla para reconfimar mails y publicidad.
*/

import React, { useState, useEffect } from "react";

//REDUX
import { useDispatch } from "react-redux";
import { changeUserAction } from "../../redux/actions/userActions";

//COMPONENT
import AlertDialog from "../../components/AlertDialog";

//PAGE
import PrivacityPolicy from "../footer/PrivacyPolicy";

//#region CSS
import { makeStyles } from "@material-ui/core/styles";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
const useStyles = makeStyles(theme => ({
  root: {
    marginTop: "10px",
    display: "flex"
  },
  border: {
    boxShadow: "0px 0px 3px 1px #9abf3a",
    paddingTop: "40px",
    paddingBottom: "40px",
    marginTop: "60px",
    marginBottom: "50px"
  },
  link: {
    color: "blue",
    cursor: "pointer"
  },
  labelBig: {
    fontSize: "1.25rem",
    align: "justify"
  },
  checkboxError: {
    borderStyle: "solid",
    borderRadius: "5px",
    borderWidth: "1px",
    borderColor: "red",
    marginTop: "1px",
  }
}));
//#endregion

function EmailConfirmed({ history, match }) {
  const classes = useStyles();

  const { userId, reConfirm, mail } = match.params;

  const [values, setValues] = useState({
    isPrivacity: false,
    isPublicity: false,
  });
  const [checkValues, setCheckValues] = useState({
    isPrivacity: false,
    isPublicity: false,
  });
  const [formValues, setFormValues] = useState({
    showPrivacity: false
  });

  //#region DISPATCH & SELECTOR
  const dispatch = useDispatch();

  //#endregion

  const handleClickBoolean = prop => event => {
    setValues({ ...values, [prop]: !values[prop] });
    setCheckValues({ ...checkValues, [prop]: false });
  };

  //#region OnClick
  const onClickGoToPrivacity = () => {
    setFormValues({ ...formValues, showPrivacity: !formValues.showPrivacity });
  };
  const onClickBackLogin = () => {
    if (reConfirm === "True") {
      if (!values.isPrivacity || !values.isPublicity) {
        setCheckValues({ ...checkValues, isPrivacity: !values.isPrivacity, isPublicity: !values.isPublicity });
      } else {
        const changeUser = (userId, user) => dispatch(changeUserAction(userId, user));
        const user = {
          isPublicity: true,
          isPrivacity: true,
          isConfirm: true
        }
        changeUser(userId, user).then(v => {
          history.push("/" + mail);
        }).catch(e => {
          console.log(e);
        });
      }
    } else {
      history.push("/" + mail);
    }
  };
  //#endregion

  useEffect(() => {
    if (reConfirm === "True") {

    } else {
      setValues({ ...values, isPrivacity: true, isPublicity: true });
      const changeUser = (userId) => dispatch(changeUserAction(userId));
      changeUser(userId);
    }
    // eslint-disable-next-line
  }, [dispatch, userId, reConfirm])

  return (
    <div className={classes.root}>
      <AlertDialog
        show={formValues.showPrivacity}
        setShow={v => {
          setFormValues({ ...formValues, showPrivacity: v });
        }}
      >
        <PrivacityPolicy />
      </AlertDialog>
      <Grid container spacing={2} justify="center" alignItems="center">
        <Fade in={true} timeout={1000}>
          <Grid item xs={11} md={6} lg={4} xl={3}>
            <Box textAlign="center">
              <img
                alt="Logo"
                src={`${process.env.PUBLIC_URL}/assets/img/logo_V2.png`}
                title="Logo"
                height="100px"
                className="mt-5"
              />
            </Box>
            <Grid
              item
              xs={12}
              className={`${classes.border} pt-5 pb-5 pl-3 pr-3`}
            >
              <Box textAlign="center">
                <Typography color="secondary" variant="h5" data-lang="email_confirmed_title">
                  Email confirmado
                </Typography>
              </Box>
              <Box textAlign="center">
                <label align="justify" className="mb-0 mt-4" data-lang-html="email_confirmed_message">
                  {reConfirm === "True" ? "Enhorabuena ya puedes iniciar sesión en Ilusiona Club, después de validar nuestras condiciones." : "Enhorabuena ya puedes iniciar sesión en Ilusiona Club."}
                </label>
              </Box>
              {reConfirm === "True" ?
                <React.Fragment>
                  <Grid item xs={12} className={`${checkValues.isPrivacity ? classes.checkboxError : null} mt-4 pb-0`}>
                    <FormControlLabel
                      control={<Checkbox color="primary" onClick={handleClickBoolean("isPrivacity")} checked={values.isPrivacity} />}
                      label={
                        <label align="justify" className="mb-0" data-lang-html="email_confirmed_privacy_label">
                          Soy mayor de 18 años y declaro haber leído y acepto las condiciones de uso y la
                        <span className={classes.link} onClick={onClickGoToPrivacity}>
                            {" "}
                            política de privacidad
                        </span>
                        </label>
                      }
                    />
                  </Grid>
                  <Grid item xs={12} className={`${checkValues.isPublicity ? classes.checkboxError : null} pt-0`}>
                    <FormControlLabel
                      control={<Checkbox color="primary" onClick={handleClickBoolean("isPublicity")} checked={values.isPublicity} />}
                      label={
                        <label align="justify" className="mb-0" data-lang="email_confirmed_publicity_label">
                          Deseo recibir promociones del Club Ilusiona
                        </label>
                      }
                    />
                  </Grid>
                </React.Fragment> : null}
              <div style={{ textAlign: "center" }}>
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  fullWidth
                  style={{ width: "80%" }}
                  className={"mt-4"}
                  onClick={onClickBackLogin}
                  data-lang="register_go_to_club"
                >
                  Entrar al Club
                </Button>
              </div>
            </Grid>
          </Grid>
        </Fade>
      </Grid>
    </div>
  );
}

export default EmailConfirmed;
